import type { CustdevAudienceRules, CustdevSettings } from '../../api/services/custdev'

export type CustdevDraft = {
  experienceCallEnabled: boolean
  minDaysSinceFirstLaunch: string
  maxDaysSinceFirstLaunch: string
  minAppLaunches: string
  maxAppLaunches: string
  minAppVersion: string
  maxAppVersion: string
  adKeywords: string
  bookingUrl: string
  separateAudiences: boolean
  powerUsers: boolean
  pelvicAds: boolean
  addonBuyers: boolean
  campaignId: string
}

export const draftFrom = (settings: CustdevSettings): CustdevDraft => ({
  experienceCallEnabled: settings.experienceCallEnabled,
  minDaysSinceFirstLaunch: String(settings.rules.minDaysSinceFirstLaunch),
  maxDaysSinceFirstLaunch: settings.rules.maxDaysSinceFirstLaunch?.toString() ?? '',
  minAppLaunches: String(settings.rules.minAppLaunches),
  maxAppLaunches: settings.rules.maxAppLaunches?.toString() ?? '',
  minAppVersion: settings.rules.minAppVersion,
  maxAppVersion: settings.rules.maxAppVersion ?? '',
  adKeywords: settings.rules.adNameContainsAny.join(', '),
  bookingUrl: settings.rules.bookingUrl,
  separateAudiences: !!settings.rules.audiences,
  powerUsers: settings.rules.audiences?.powerUsers ?? false,
  pelvicAds: settings.rules.audiences?.pelvicAds ?? false,
  addonBuyers: settings.rules.audiences?.addonBuyers ?? false,
  campaignId: settings.rules.campaignId ?? '',
})

export const rulesFrom = (draft: CustdevDraft): CustdevAudienceRules => ({
  minDaysSinceFirstLaunch: Number(draft.minDaysSinceFirstLaunch),
  maxDaysSinceFirstLaunch: draft.maxDaysSinceFirstLaunch === '' ? null : Number(draft.maxDaysSinceFirstLaunch),
  minAppLaunches: Number(draft.minAppLaunches),
  maxAppLaunches: draft.maxAppLaunches === '' ? null : Number(draft.maxAppLaunches),
  minAppVersion: draft.minAppVersion.trim(),
  maxAppVersion: draft.maxAppVersion.trim() || null,
  adNameContainsAny: [...new Set(draft.adKeywords.split(/[,\n]/).map(word => word.trim().toLowerCase()).filter(Boolean))],
  bookingUrl: draft.bookingUrl.trim(),
  audiences: draft.separateAudiences ? { powerUsers: draft.powerUsers, pelvicAds: draft.pelvicAds, addonBuyers: draft.addonBuyers } : null,
  campaignId: draft.campaignId.trim() || null,
})
